import React from 'react';
import { createPortal } from 'react-dom';
import './SafetyReportPrint.css';

function SafetyReportMeetingModal({ show, onClose, project, modalSummary, aprvLines }) {
  if (!show || !project) return null;

  const projName = project.name || '-';
  const projWriter = project.writeName || '-';

  const summaries = Array.isArray(modalSummary) ? modalSummary : (modalSummary ? [modalSummary] : []);

  const handlePrint = () => {
    const printContent = document.getElementById('meeting-printable-area');
    if (!printContent) return;

    const printWindow = window.open('', '_blank', 'width=1000,height=900');
    if (!printWindow) {
      alert('팝업 차단이 설정되어 있습니다. 브라우저 팝업 차단을 해제한 후 다시 시도해주세요.');
      return;
    }

    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <title>위험성평가 회의록 출력</title>
          <style>
            @media print {
              @page { size: A4; margin: 12mm; }
              body { padding: 0 !important; background: #ffffff !important; color: #000000 !important; font-family: Pretendard, -apple-system, sans-serif; }
              .no-print { display: none !important; }
            }
            body { padding: 25px; background: #ffffff; color: #000000; font-family: Pretendard, -apple-system, sans-serif; line-height: 1.5; }
            .no-print { display: none !important; }
            /* 필수 부트스트랩 클래스 내장화 (네트워크 로딩 완벽 제거) */
            table { width: 100% !important; border-collapse: collapse !important; margin-bottom: 1.5rem; }
            th, td { border: 1px solid #dee2e6; padding: 0.75rem; vertical-align: middle; }
            .text-center { text-align: center; } .fw-bold { font-weight: bold; }
            .bg-light, .table-light { background-color: #f8fafc !important; }
            .text-primary { color: #0d6efd; } .text-success { color: #198754; } .text-muted { color: #6c757d; }
            .text-dark { color: #212529; } .text-white { color: #fff; }
            .d-flex { display: flex; } .justify-content-between { justify-content: space-between; } .justify-content-end { justify-content: flex-end; } .align-items-center { align-items: center; }
            .gap-1\\.5 { gap: 0.375rem; } .gap-2 { gap: 0.5rem; }
            .border-bottom { border-bottom: 1px solid #dee2e6; } .border-top { border-top: 1px solid #dee2e6; } .border { border: 1px solid #dee2e6; }
            .rounded-3 { border-radius: 0.5rem; }
            .badge { display: inline-block; padding: 0.35em 0.65em; font-size: 0.75em; font-weight: 700; text-align: center; border-radius: 0.25rem; color: #fff; }
            .bg-secondary { background-color: #6c757d; } .bg-success-subtle { background-color: #d1e7dd; color: #0f5132; }
            .mb-0 { margin-bottom: 0; } .mb-1 { margin-bottom: 0.25rem; } .mb-2 { margin-bottom: 0.5rem; } .mb-3 { margin-bottom: 1rem; } .mb-4 { margin-bottom: 1.5rem; } .mb-5 { margin-bottom: 3rem; }
            .mt-1 { margin-top: 0.25rem; } .mt-4 { margin-top: 1.5rem; } .mt-5 { margin-top: 3rem; }
            .pt-2 { padding-top: 0.5rem; } .pt-3 { padding-top: 1rem; } .pt-4 { padding-top: 1.5rem; } .pb-2 { padding-bottom: 0.5rem; } .pb-3 { padding-bottom: 1rem; }
            .p-3 { padding: 1rem; } .p-4 { padding: 1.5rem; }
            .small { font-size: 0.875em; } .fs-6 { font-size: 1rem; }
            .editor-content-box > *:first-child { margin-top: 0 !important; }
            .editor-content-box p:first-child { margin-top: 0 !important; }
            .editor-content-box p { margin-top: 0 !important; margin-bottom: 0.5rem !important; }
            .editor-content-box p:last-child { margin-bottom: 0 !important; }
          </style>
        </head>
        <body>
          <div>
            ${printContent.innerHTML}
          </div>
          <script>
            // 외부 네트워크 호출이 일절 없으므로 즉각 인쇄창 호출 가능
            window.onload = function() {
              window.print();
            };
            window.onafterprint = function() {
              window.close();
            };
          </script>
        </body>
      </html>
    `);
    printWindow.document.close();
  };

  return createPortal(
    <div
      className="report-viewer-overlay"
      style={{
        zIndex: 999999,
        background: 'rgba(15, 23, 42, 0.75)',
        backdropFilter: 'blur(5px)',
        WebkitBackdropFilter: 'blur(5px)',
        display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px'
      }}
      onClick={onClose}
    >
      <div
        className="bg-white rounded-3 shadow-lg border-0 overflow-hidden"
        style={{ width: '100%', maxWidth: '980px', maxHeight: '92vh', display: 'flex', flexDirection: 'column' }}
        onClick={e => e.stopPropagation()}
      >
        {/* 모달 상단 툴바 (비인쇄 영역) */}
        <div className="text-dark px-4 d-flex justify-content-between align-items-center no-print border-bottom" style={{ backgroundColor: '#e2e8f0', minHeight: '58px' }}>
          <div className="d-flex align-items-center gap-2" style={{ maxWidth: '90%' }}>
            <h5 className="fw-bold mb-0 text-dark text-truncate" style={{ fontSize: '1.15rem' }} title={`[회의록] ${projName}`}>
              [회의록] {projName}
            </h5>
          </div>
        </div>

        {/* 본문 윗여백 제거 및 줄간격 미지정 시 기본 1.5 적용 커스텀 스타일 */}
        <style>{`
          .editor-content-box { padding-top: 0.5rem !important; line-height: 1.5; }
          .editor-content-box > *:first-child { margin-top: 0 !important; }
          .editor-content-box p:first-child { margin-top: 0 !important; }
          .editor-content-box p { margin-top: 0 !important; margin-bottom: 0.5rem !important; line-height: 1.5; }
          .editor-content-box p:last-child { margin-bottom: 0 !important; }
          .editor-content-box, .editor-content-box p, .editor-content-box div, .editor-content-box span { line-height: 1.5; }
        `}</style>

        {/* 모달 본문 영역 (A4 정식 보고서 UI) */}
        <div className="p-4 bg-white text-dark overflow-auto" id="meeting-printable-area" style={{ flex: 1, fontFamily: 'Pretendard, sans-serif' }}>
          {summaries.map((summary, idx) => {
            const meetingTitle = summary?.title || '미지정';
            const meetingDate = summary?.date || '미지정';
            const meetingTime = summary?.time || '';
            const meetingDuration = summary?.duration ? `(${summary.duration})` : '';
            const meetingLocation = summary?.location || '미지정';
            const meetingAgenda = summary?.agenda || '1. 사업장 유해위험요인 파악 결과 심의 및 승인 건\n2. 고위험성(상/중 등급) 공정에 대한 안전보건 감소대책 실행계획 확정 건\n3. 기타 근로자 현장 건의사항 청취 및 개선 조치 방향 토의';
            const meetingConclusion = summary?.content || '[미등록] 작성된 회의록 및 총평 내역이 없습니다.';
            const meetingAttendeesList = Array.isArray(summary?.attendeesList) ? summary.attendeesList : [];

            return (
              <div key={summary?.id || idx} style={{ pageBreakAfter: idx < summaries.length - 1 ? 'always' : 'auto', marginBottom: idx < summaries.length - 1 ? '60px' : '0' }}>
                <div className="px-3 pt-1 pb-1">
                  <div className="text-center mb-2 border-bottom pb-2">
                    <span className="badge bg-secondary mb-2 px-3 py-1 small">산업안전보건법 제36조 이행 기록 대장</span>
                    <h2 className="fw-bold mb-2" style={{ fontSize: '1.75rem', color: '#0f172a' }}>위험성평가 위원회 회의록</h2>
                    <p className="text-muted m-0" style={{ fontSize: '0.9rem' }}>사업장 노사 안전보건위원 합동 심의 및 개선대책 확정 회의 기록</p>
                  </div>

                  {/* 회의 개요 정보 표 */}
                  <table className="table table-bordered align-middle mb-4" style={{ fontSize: '0.9rem' }}>
                    <tbody>
                      <tr>
                        <th className="table-light text-center" style={{ width: '22%', background: '#f8fafc' }}>평 가 프 로 젝 트</th>
                        <td className="fw-bold text-dark">{projName}</td>
                      </tr>
                      <tr>
                        <th className="table-light text-center" style={{ background: '#f8fafc' }}>회 의 종 류 (제 목)</th>
                        <td className="fw-bold text-dark">{meetingTitle}</td>
                      </tr>
                      <tr>
                        <th className="table-light text-center" style={{ background: '#f8fafc' }}>회 의 일 시 / 장 소</th>
                        <td>{meetingDate} {meetingTime} {meetingDuration} / {meetingLocation}</td>
                      </tr>
                      <tr>
                        <th className="table-light text-center" style={{ background: '#f8fafc' }}>회 의 안 건</th>
                        <td style={{ whiteSpace: 'pre-wrap' }}>
                          {meetingAgenda}
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  {/* 회의록 상세 의결 내용 */}
                  <div className="mt-4">
                    <h5 className="fw-bold mb-3 d-flex align-items-center gap-1.5" style={{ fontSize: '1rem' }}>
                      ■ 위험성평가 회의 내용 및 의결 사항
                    </h5>
                    <div
                      className="p-3 border rounded-3 bg-light mb-2 editor-content-box"
                      style={{ lineHeight: 1.5, fontSize: '0.9rem', minHeight: '250px' }}
                      dangerouslySetInnerHTML={{ __html: meetingConclusion }}
                    />
                  </div>

                  {/* 회의 참석자 서명 대장 */}
                  <div className="mt-4">
                    <h5 className="fw-bold mb-3 d-flex align-items-center gap-1.5" style={{ fontSize: '1rem' }}>
                      ■ 위험성평가 위원회 참석자 서명 대장
                    </h5>
                    <table className="table table-bordered text-center align-middle" style={{ fontSize: '0.9rem' }}>
                      <thead className="table-light" style={{ background: '#f8fafc' }}>
                        <tr>
                          <th style={{ width: '8%' }}>순번</th>
                          <th style={{ width: '25%' }}>소속 부서</th>
                          <th style={{ width: '20%' }}>성명</th>
                          <th style={{ width: '18%' }}>직급</th>
                          <th>서명 확인 상태</th>
                        </tr>
                      </thead>
                      <tbody style={{ fontSize: '0.85rem' }}>
                        {meetingAttendeesList.length === 0 ? (
                          <tr>
                            <td colSpan="5" className="text-center text-muted" style={{ padding: '2rem 0' }}>
                              등록된 회의 참석자가 없습니다.
                            </td>
                          </tr>
                        ) : (
                          meetingAttendeesList.map((att, attIdx) => (
                            <tr key={att.user_id || attIdx}>
                              <td>{attIdx + 1}</td>
                              <td>{att.dept_name || att.deptName || att.department || (att.user && att.user.org ? att.user.org.dept_name : null) || '-'}</td>
                              <td className="fw-bold text-dark">{att.user_name || '-'}</td>
                              <td>{att.user_position || '-'}</td>
                               <td className="text-center fw-bold" style={{ height: '40px', verticalAlign: 'middle' }}>
                                {(() => {
                                  const signImg = att.signature_url || att.signature || att.sign_url || att.sign_path || att.user_sign || (att.user ? (att.user.user_sign || att.user.signature_url || att.user.sign_url) : null);
                                  return signImg ? (
                                    <img src={signImg} alt="서명" style={{ maxHeight: '30px', maxWidth: '80px', objectFit: 'contain' }} />
                                  ) : (
                                    <span style={{ color: '#94a3b8', fontWeight: 'normal', fontSize: '0.85rem' }}>(인)</span>
                                  );
                                })()}
                               </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>

                  {/* 결재선 정보 */}
                  {aprvLines && aprvLines.length > 0 && (
                    <div className="d-flex justify-content-end mt-2 pt-1">
                      <table className="table table-bordered text-center align-middle" style={{ maxWidth: '480px', fontSize: '0.85rem', marginBottom: '0.5rem' }}>
                        <thead>
                          <tr className="table-light" style={{ background: '#f8fafc' }}>
                            <th style={{ width: '33%' }}>작성자</th>
                            <th style={{ width: '33%' }}>검토자</th>
                            <th style={{ width: '34%' }}>승인자</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr style={{ verticalAlign: 'middle' }}>
                            <td className="fw-bold text-primary">
                              {aprvLines[0]?.user_name || projWriter}
                              <div className="text-muted" style={{ fontSize: '0.75rem' }}>{aprvLines[0]?.user_position || '안전관리자'}</div>
                              {(() => {
                                const s = aprvLines[0]?.signature_url || aprvLines[0]?.signature || aprvLines[0]?.sign_url;
                                return s ? (
                                  <img src={s} alt="서명" style={{ maxHeight: '48px', maxWidth: '85px', objectFit: 'contain', marginTop: '4px' }} />
                                ) : (
                                  <div className="text-muted mt-2" style={{ fontSize: '0.8rem' }}>(인)</div>
                                );
                              })()}
                            </td>
                            <td className="text-muted">
                              {aprvLines[1]?.status === 'approved' ? (
                                <>
                                  <span className="fw-bold text-dark">{aprvLines[1]?.user_name}</span>
                                  <div style={{ fontSize: '0.75rem' }}>{aprvLines[1]?.user_position}</div>
                                  {(() => {
                                    const s = aprvLines[1]?.signature_url || aprvLines[1]?.signature || aprvLines[1]?.sign_url;
                                    return s ? (
                                      <img src={s} alt="서명" style={{ maxHeight: '48px', maxWidth: '85px', objectFit: 'contain', marginTop: '4px' }} />
                                    ) : (
                                      <div className="text-muted mt-2" style={{ fontSize: '0.8rem' }}>(인)</div>
                                    );
                                  })()}
                                </>
                              ) : <div style={{ fontSize: '0.8rem' }}>(인)</div>}
                            </td>
                            <td className="text-muted">
                              {aprvLines[2]?.status === 'approved' ? (
                                <>
                                  <span className="fw-bold text-dark">{aprvLines[2]?.user_name}</span>
                                  <div style={{ fontSize: '0.75rem' }}>{aprvLines[2]?.user_position}</div>
                                  {(() => {
                                    const s = aprvLines[2]?.signature_url || aprvLines[2]?.signature || aprvLines[2]?.sign_url;
                                    return s ? (
                                      <img src={s} alt="서명" style={{ maxHeight: '48px', maxWidth: '85px', objectFit: 'contain', marginTop: '4px' }} />
                                    ) : (
                                      <div className="text-muted mt-2" style={{ fontSize: '0.8rem' }}>(인)</div>
                                    );
                                  })()}
                                </>
                              ) : <div style={{ fontSize: '0.8rem' }}>(인)</div>}
                            </td>
                          </tr>
                          <tr className="table-light" style={{ fontSize: '0.75rem', background: '#f8fafc' }}>
                            <td>{aprvLines[0]?.updated_at ? aprvLines[0].updated_at.split('T')[0] : ''}</td>
                            <td>{aprvLines[1]?.status === 'approved' && aprvLines[1]?.updated_at ? aprvLines[1].updated_at.split('T')[0] : ''}</td>
                            <td>{aprvLines[2]?.status === 'approved' && aprvLines[2]?.updated_at ? aprvLines[2].updated_at.split('T')[0] : ''}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  )}


                  {/* 별지 첨부파일 (이미지) 그리드 렌더링 영역 */}
                  {Array.isArray(summary?.files) && summary.files.filter(f => f.mimeType && f.mimeType.startsWith('image/')).length > 0 && (
                    <div className="mt-4">
                      <h5 className="fw-bold mb-3 d-flex align-items-center gap-1.5" style={{ fontSize: '1rem' }}>
                        ■ 사진 첨부 (증빙자료)
                      </h5>
                      <div style={{ display: 'block', fontSize: 0 }}>
                        {summary.files.filter(f => f.mimeType && f.mimeType.startsWith('image/')).map((file, fIdx) => (
                          <div key={file.id || fIdx} style={{ 
                            display: 'inline-block', 
                            width: '48%', 
                            marginRight: fIdx % 2 === 0 ? '4%' : '0', 
                            marginBottom: '1.5rem',
                            border: '1px solid #dee2e6', 
                            boxSizing: 'border-box',
                            verticalAlign: 'top',
                            pageBreakInside: 'avoid',
                            backgroundColor: '#ffffff',
                            WebkitPrintColorAdjust: 'exact',
                            printColorAdjust: 'exact'
                          }}>
                            <div className="fw-bold text-truncate" style={{ 
                              fontSize: '0.85rem', 
                              backgroundColor: '#f1f5f9', 
                              borderBottom: '1px solid #dee2e6',
                              padding: '8px 12px',
                              textAlign: 'left',
                              color: '#1e293b',
                              WebkitPrintColorAdjust: 'exact',
                              printColorAdjust: 'exact'
                            }}>
                              {file.originalName}
                            </div>
                            <div style={{ height: '220px', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '10px' }}>
                              <img 
                                src={file.path} 
                                alt={file.originalName} 
                                style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
                              />
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  {idx < summaries.length - 1 && (
                    <div className="d-print-none" style={{ borderTop: '2px dashed #94a3b8', margin: '40px 0', position: 'relative', textAlign: 'center' }}>
                      <span style={{ position: 'absolute', top: '-13px', left: '50%', transform: 'translateX(-50%)', background: '#fff', padding: '0 10px', color: '#94a3b8', fontSize: '0.85rem' }}>
                        <i className="fas fa-cut me-1"></i> 문서 구분선 (다음 페이지)
                      </span>
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>

        {/* 모달 하단 툴바 (비인쇄 영역 - 회색 배경) */}
        <div className="px-4 py-2 d-flex justify-content-end align-items-center gap-2 no-print border-top" style={{ backgroundColor: '#f1f5f9', minHeight: '63px' }}>
          <button type="button" className="btn btn-primary btn-sm fw-bold px-3.5 py-2 d-flex align-items-center gap-1.5" onClick={handlePrint}>
            <i className="bi bi-printer-fill"></i> 바로 인쇄 / PDF 저장
          </button>
          <button type="button" className="btn btn-dark btn-sm px-4 py-2" onClick={onClose}>
            닫기
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}

export default SafetyReportMeetingModal;
